import { render } from "./RequestSupportSuccess.vue?vue&type=template&id=7dbedb64&scoped=true"
const script = {}

import "./RequestSupportSuccess.vue?vue&type=style&index=0&id=7dbedb64&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dbedb64"]])

export default __exports__